import { AccordionTile as UiLibAccordionTile, LuneTheme } from '@lune-fe/lune-ui-lib'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import Text from '@mui/material/Typography'
import React from 'react'

export default function AccordionTile({
    title,
    description,
    expanded,
}: {
    title: string
    description: React.ReactNode
    expanded?: boolean
}) {
    const { palette } = LuneTheme
    return (
        <UiLibAccordionTile
            expanded={expanded}
            sx={{
                background: 'transparent',
            }}
            title={<>{title}</>}
            icon={<HelpOutlineIcon />}
        >
            <Text variant={'body3'} sx={{ color: palette.Grey600 }}>
                {description}
            </Text>
        </UiLibAccordionTile>
    )
}
